var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMypage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.81 53.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.41,27.55c-7.59,0-13.77-6.18-13.77-13.77S15.81,0,23.41,0s13.77,6.18,13.77,13.77c0,1.83-.35,3.6-1.05,5.28-.5,1.22-1.9,1.79-3.12,1.29-1.22-.5-1.79-1.9-1.29-3.12.45-1.09.68-2.25.68-3.45,0-4.97-4.04-9.01-9.01-9.01s-9.01,4.04-9.01,9.01,4.04,9.01,9.01,9.01c1.32,0,2.38,1.07,2.38,2.38s-1.07,2.38-2.38,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.31,53.14H5.5c-1.51,0-2.92-.66-3.97-1.87-1.21-1.4-1.74-3.3-1.46-5.22,1.01-6.92,4.18-13.11,8.93-17.44.97-.89,2.48-.82,3.37.15.89.97.82,2.48-.15,3.37-3.94,3.59-6.57,8.78-7.42,14.6-.09.64.12,1.15.35,1.42.06.07.21.22.36.22h35.81c.14,0,.28-.14.35-.22.24-.27.45-.8.36-1.46-1.6-10.92-9.6-19.15-18.61-19.15-1.32,0-2.38-1.07-2.38-2.38s1.07-2.38,2.38-2.38c11.54,0,21.35,9.77,23.33,23.22.28,1.91-.27,3.88-1.47,5.27-1.04,1.21-2.45,1.87-3.96,1.87Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypage);
export default __webpack_public_path__ + "static/media/mypage.9213b9d456e7fb85ecfbdcf774eb64d9.svg";
export { ForwardRef as ReactComponent };